export const BookingStateMap: Record<string, { color: string; icon: string }> = {
  PENDING: { color: 'warning', icon: 'm_wait-small' },
  ACCEPTED: { color: 'warning', icon: 'm_edit' },
  DECLINED: { color: 'error', icon: 'm_close' },
  ENDED: { color: 'error', icon: 'm_close' },
  CANCELLED: { color: 'error', icon: 'm_close' },
  APPROVED: { color: 'success', icon: 'm_checkmark-small' },
  ACTIVE: { color: 'success', icon: 'm_checkmark-small' },
  BOOKED: { color: 'success', icon: 'm_checkmark-small' },
  AUTOMATICALLY_APPROVED: { color: 'success', icon: 'm_checkmark-small' },
  UPGRADED: { color: 'light', icon: 'm_plus-small' },
  UPGRADE_IN_PROGRESS: { color: 'warning', icon: 'm_new-small' },
};

export const PriceRequestStateMap: Record<string, { color: string; icon: string }> = {
  REQUESTED: { color: 'warning', icon: 'm_wait-small' },
  OPEN: { color: 'secondary', icon: 'm_new-small' },
  RETRACTED: { color: 'error', icon: 'm_close' },
  IN_PROGRESS: { color: 'warning', icon: 'm_edit' },
  OFFER_SENT: { color: 'success', icon: 'm_sent-small' },
  PRICE_OFFER: { color: 'warning', icon: 'm_new-small' },
  OFFER_EXPIRED: { color: 'error', icon: 'm_close' },
  OFFER_ACCEPTED: { color: 'success', icon: 'm_checkmark-small' },
  OFFER_REJECTED: { color: 'error', icon: 'm_close' },
  REJECTED: { color: 'error', icon: 'm_close' },
  PRICE_REQUEST_REJECTED: { color: 'error', icon: 'm_close' },
  PRICE_REQUEST_REJECTED_BY_LA: { color: 'error', icon: 'm_close' },
};

export const CartridgeGroupStateMap: Record<string, { color: string; icon: string; fill: string }> = {
  PARTIAL_BOOKED: { color: 'success', icon: 'm_checkmark-small', fill: 'outlined' },
  FULLY_BOOKED: { color: 'success', icon: 'm_checkmark-small', fill: 'solid' },
  ONGOING_PROCESS: { color: 'warning', icon: 'm_in-progress', fill: 'solid' },
};
